// extracted by mini-css-extract-plugin
export default {"signing":"HeaderNavbar_signing__iq8VZ","navGroup":"HeaderNavbar_navGroup__+aItI"};